import React from "react";
import { Route } from "react-router-dom";
import Monitoring from "../components/monitoring/monitoring";

//Definición de los componentes y rutas de la aplicación
class AppRoutes extends React.Component {
  render() {
    return (
      <div>
        <Route exact path="/" component={Monitoring}></Route>
      </div>
    );
  }
}

export default AppRoutes;
